import { NgModule } from '@angular/core';
import { NgGrid, NgGridItem, NgGridPlaceholder } from '../main';
export var NgGridModule = (function () {
    function NgGridModule() {
    }
    NgGridModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NgGrid, NgGridItem, NgGridPlaceholder],
                    entryComponents: [NgGridPlaceholder],
                    exports: [NgGrid, NgGridItem]
                },] },
    ];
    /** @nocollapse */
    NgGridModule.ctorParameters = function () { return []; };
    return NgGridModule;
}());
//# sourceMappingURL=NgGrid.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/angular2-grid/modules/NgGrid.module.js
// module id = DT7u
// module chunks = 3